var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.113 0C4.091 0 0 3.928 0 8.75s4.09 8.75 9.113 8.75c5.022 0 9.113-3.928 9.113-8.75S14.136 0 9.113 0zm0 1.75c4.037 0 7.29 3.124 7.29 7s-3.253 7-7.29 7-7.29-3.124-7.29-7 3.253-7 7.29-7zm-.911 2.625v3.5H4.557v1.75h3.645v3.5h1.822v-3.5h3.646v-1.75h-3.646v-3.5H8.202z"
  })));
}
export default SvgPlus;